import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfOdontogramasConvenciones } from '@/modules/Configuracion/interfaces'
export class OdontogramaConvencionesService extends BaseService<IConfOdontogramasConvenciones> {
  constructor () {
    super({
      baseUrl: 'system/odontogramconvenciones/'
    })
  }
}
